import React from 'react';
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import {CaseForms} from "../../../../helpers/enums";

import './EstensioneReteEsistenteCase.scss';
import useSimpleCaseData from "../../../../hooks/useSimpleCaseData";

const EstensioneReteEsistenteCase = () => {
  const {data, blockCaseIfNoContract} = useSimpleCaseData();
  return (
    <div
      className="EstensioneReteEsistenteCase"
      data-testid="EstensioneReteEsistenteCase"
    >
      <CaseGenerator
        type={CaseForms.EstensioneReteEsistente}
        initialValues={data}
        blockIfNoContracts={blockCaseIfNoContract}
      />
    </div>
  );
};

export default EstensioneReteEsistenteCase;
